module.exports = __webpack_public_path__ + "static/media/instagram-gray.80b060fa.svg";